export default __webpack_public_path__ + "static/media/energy-more-info.9aa28b3e.svg";